<form
  (ngSubmit)="handleSubmit()"
  [formGroup]="newPinForm"
  class="flex flex-col justify-center w-full m-auto px-6 py-8 lg:py-11 md:max-w-[70%]">
  <span class="lg:text-2xl lg:leading-10 font-medium mb-7 lg:mb-[53px]">Set your new PIN</span>

  <bey-input-pin
    label="Set 4 digit PIN"
    formControlName="pin"
    autocomplete="current-password"
    [control]="newPinForm.controls['pin']"
    getElementId>
  </bey-input-pin>

  <bey-input-pin
    label="Confirm PIN"
    formControlName="confirm_pin"
    autocomplete="current-password"
    [control]="newPinForm.controls['confirm_pin']"
    getElementId>
  </bey-input-pin>

  <div class="mb-8 flex items-center justify-between">
    <a class="text-blue-light font-medium text-base" (click)="onBackClick()" getElementId getElementIdDescription="back"
      >Back</a
    >
    <bey-button
      placeholder="Finish"
      classList="px-12"
      [submit]="true"
      [disabled]="!newPinForm.valid"
      [isLoading]="resetUserPinIsLoading$ | async"
      getElementId
      getElementIdDescription="finish"></bey-button>
  </div>
</form>
